import { checkinApi } from '@/services/api/httpClient';

const actions = {
  async getHealthInsuranceByBrandId({ commit, getters }) {
    commit('enableLoader', true);

    const routePath = '/health-insurance';
    const params = {
      brandId: getters?.getBrandUnitIdVariables?.brandId,
    };

    try {
      const response = await checkinApi().get(routePath, { params });

      commit('SET_HEALTH_INSURANCE_LIST', response.data);
    } catch (error) {
      console.error(error);
    } finally {
      commit('enableLoader', false);
    }
  },

  async getHealthInsuranceVariables({ commit, getters }, { clientId, admissionOrigin }) {
    commit('enableLoader', true);

    const routePath = '/health-insurance/variables';
    const params = {
      brandId: getters?.getBrandUnitIdVariables?.brandId,
      clientId,
      admissionOrigin,
    };

    try {
      const response = await checkinApi().get(routePath, { params });

      if (!response?.data?.variaveis) return;

      commit('SET_HEALTH_INSURANCE_VARIABLES', response.data.variaveis);
    } catch (error) {
      console.error(error);
    } finally {
      commit('enableLoader', false);
    }
  },

  async healthInsuranceVariablesSelector(
    { commit },
    { clientId, brandId, negotiationVariables, admissionOrigin },
  ) {
    commit('enableLoader', true);

    const routePath = '/health-insurance/variables-selector';
    const params = {
      brandId,
      clientId,
      negotiationVariables,
      admissionOrigin,
    };

    try {
      const response = await checkinApi().get(routePath, { params });

      commit('SET_HEALTH_INSURANCE_VARIABLES', response.data);
    } catch (error) {
      console.error(error);
    } finally {
      commit('enableLoader', false);
    }
  },

  async getLatestHealthInsuranceCards({ getters, commit }) {
    const admissionId = getters.getCurrentAdmissionState.data.id;
    const mdmId = getters.getMdmState.data.id;
    const brandId = getters.getBrandUnitState.data.currentBrand.brandId;

    const url = `/admission/${admissionId}/recent-health-insurance-cards?brandId=${brandId}&mdmIdPatient=${mdmId}`;
    try {
      const resp = await checkinApi().get(url);

      commit('SET_HEALTH_INSURANCE_RECENT_CARDS', resp.data);
      return resp.data;
    } catch (error) {
      return false;
    }
  },

  async validateHealthInsuranceVariables(
    { getters, commit },
    { clientId, brandId, negotiationVariables, multiBrand = null },
  ) {
    const url = '/admission/healthinsurance/validate';
    const params = {
      clientId,
      brandId,
      negotiationVariables,
      multiBrand,
    };

    try {
      const response = await checkinApi().post(url, params);
      return response.data.configuracaoValida;
    } catch (error) {
      console.log(error);
      return false;
    }
  },
};

export default actions;
